import { Component, Prop, h } from '@stencil/core';
import { DATA_VISUALIZATION_HUE, DATA_VISUALIZATION_HUE_VARIANT } from '../../constants';
import { getCssColorCode } from '../../utils/color-helper';

export type Layout = 'default' | 'wrap';

@Component({
  tag: 'uui-percentile-bar-legend',
  styleUrl: 'uui-percentile-bar-legend.scss',
  shadow: true
})
export class UuiPercentileBarLegend {

  @Prop() ranges: string[] | string = ['Not Scored', '0-25', '26-50', '51-75', '76-100']; // string type needed to pass input from storybook
  @Prop() colors?: string[] | string = [];
  @Prop() includeNotScoredLabel: boolean = true;
  @Prop() layout: Layout = 'default';

  public defaultColors = [
    DATA_VISUALIZATION_HUE_VARIANT.GRAY,
    DATA_VISUALIZATION_HUE_VARIANT.RED,
    DATA_VISUALIZATION_HUE_VARIANT.ORANGE,
    DATA_VISUALIZATION_HUE_VARIANT.YELLOW,
    DATA_VISUALIZATION_HUE_VARIANT.GREEN,
  ];

  componentWillLoad() {
    if (typeof this.ranges === 'string') {
      this.ranges = JSON.parse(this.ranges);
    }

    if (typeof this.colors === 'string') {
      this.colors = JSON.parse(this.colors);
    }

    if (!this.includeNotScoredLabel) {
      this.ranges = (this.ranges as string[]).slice(1); 
      this.defaultColors = this.defaultColors.slice(1);
    }
  }

  getColor(index: number): string {
    if (this.colors && this.colors.length > index) {
      return getCssColorCode(this.colors[index]);
    }

    return DATA_VISUALIZATION_HUE[this.defaultColors[index]];
  };

  render() {
    const {layout} = this;
    return (
      <div class="uui-percentile-bar-legend-container" data-mode={layout}>
        {(this.ranges as string[]).map((range, index) => (
          <div class="uui-percentile-bar-legend-item">
            <div class="uui-percentile-bar-legend-dot" style={{ 'background-color': this.getColor(index) }}></div>
            <span>{range}</span>
          </div>
        ))}
      </div>
    );
  }
}